import {
  LessonContentVideo,
  OVERLAY_VIDEO_TYPE,
  RECORD_VIDEO_TYPE,
  VIDEO_NODE_TYPE,
} from '../../../data/models/LessonContent/LessonContentBase';
import {
  LessonContentItem,
  LessonContentList,
} from '../../../data/models/LessonContent/LessonContentList';

export interface MicroreelVideoSource {
  url: string;
  startInSeconds: number;
  endInSeconds: number;
  generatedFromImage: boolean;
}

const PLAYABLE_FILE_NODE_TYPES = [
  VIDEO_NODE_TYPE,
  OVERLAY_VIDEO_TYPE,
  RECORD_VIDEO_TYPE,
];

export const getMicroreelVideoSources = (
  lessonContent?: LessonContentList,
): MicroreelVideoSource[] => {
  const items = lessonContent?.contentList?.items;
  const rootId = lessonContent?.contentList?.rootId;
  if (!items || !rootId) {
    return [];
  }

  const sources: MicroreelVideoSource[] = [];
  const visited = new Set<string>();
  let currentId: string | undefined = rootId;

  while (currentId && !visited.has(currentId)) {
    visited.add(currentId);
    const item: LessonContentItem = items[currentId];
    if (!item) break;

    if (PLAYABLE_FILE_NODE_TYPES.includes(item.data.ivNodeType)) {
      const node = item.data as LessonContentVideo;
      if (node.contentUrl) {
        sources.push({
          url: node.contentUrl,
          startInSeconds: node.startInSeconds ?? 0,
          endInSeconds: node.endInSeconds ?? 0,
          generatedFromImage: !!node.generatedFromImage,
        });
      }
    }

    currentId = item.childIds?.[0];
  }

  return sources;
};
